import React, { Component, Fragment } from 'react';
import FETCH from '../Fetch';
import { Link } from 'react-router-dom';
import FeesLoader from '../loaderComponents/FeesLoader';
import { numberFormat, getDueTime, canDisableFee } from '../utils';
import { DaysRemainingIcon, TransactionSuccessIcon } from './Svg';
// import { toast } from './Notifier';

function EmptyFees({ message }) {
  return (
    <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
      <h1>Error</h1>
      <div className="row no-gutters">
        <div className="col-lg-12 m-auto">
          <div className="card ">
            <div className="card-body">
              <div className="dashboard-transaction-container text-center">
                <div className="empty-card text-center mt-3">
                  <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                    <img
                      src={require('../assets/empty-fee.svg')}
                      className="svg"
                      alt="Min Unit"
                    />
                  </button>

                  <Fragment>
                    <p>Oops!</p>
                    <small>{message}</small>
                  </Fragment>
                </div>
                <Fragment>
                  <Link
                    className="btn btn-primary btn-primary-color  mt-5"
                    to="/"
                  >
                    Dashboard
                  </Link>
                </Fragment>
              </div>
            </div>
          </div>
          {/* card for outstanding fees */}
        </div>
      </div>

      {/* end card for news display   */}
    </main>
  );
  // return (
  //   <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
  //     <h1 className="small">Fees</h1>
  //     {/* card for registered courses display  */}
  //     <div className="row no-gutters">
  //       <div className="col-lg-12 ">
  //         <div className="card row justify-content-center align-items-center min-h-500 not-found">
  //           <div className="status-code"> Oops! </div>
  //           <div className="status-text"> {props.message}</div>
  //           <Link
  //             className="btn btn-primary btn-primary-color not-found-btn"
  //             to="/"
  //           >
  //             Dashboard
  //           </Link>
  //         </div>
  //       </div>
  //     </div>
  //   </main>
  // );
}

class Fees extends Component {
  state = {
    fees: null,
    sundry_fees: null,
    loading: true,
    cannotGetFees: false
  };
  componentDidMount() {
    // get all payable fees for the user
    FETCH.getFees()
      .then(response => {
        if (
          !response.data ||
          typeof response.data === 'string' ||
          response.status === 'error'
        ) {
          return this.setState({ cannotGetFees: true, loading: false });
        }
        this.setState({
          fees: response.data.main_fees,
          sundry_fees: response.data.sundry_fees,
          cannotGetFees: false,
          loading: false
        });
        return this.arrangeFees();
      })
      .catch(error => {
        console.log(error);
        // toast(error.message, { status: 'error', timeout: 3000 });
      });
  }

  arrangeFees = () => {
    /**
     * Reduce the fees to an array containing prerequisite_fees found in any fees
     * map through the array of prerequisite_fees to return fees whose payment_code === prerequisite fee
     * filter through the array to  remove null or undefined values
     */
    const prerequistes = this.state.fees
      .reduce((acc, curr) => {
        if (curr.prerequisite_fee !== null) {
          acc.push(curr.prerequisite_fee);
        }
        return acc;
      }, [])
      .map(id => {
        const fee = this.state.fees.find(fee => fee.payment_code === id);
        return fee;
      })
      .filter(Boolean);

    // filter through this.state.fees to return fees that are not in the array of prerequisites
    const lastOrderFees = this.state.fees.filter(
      fee => !prerequistes.find(curr => curr.payment_code === fee.payment_code)
    );

    // concatenate array of prerequisites and lastOrderFess and return
    const orderedFees = prerequistes.concat(lastOrderFees);
    return orderedFees;
  };

  render() {
    const { loading, cannotGetFees, fees } = this.state;
    if (cannotGetFees)
      return (
        <EmptyFees message="Cannot get fees at the moment, try again later" />
      );
    return (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1>My Fees</h1>
        {/* card container for dashboard transaction */}
        <div className="row">
          {this.state.loading ? (
            <FeesLoader />
          ) : (
            this.arrangeFees().map((fee, i) => {
              return (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6" key={i}>
                  {/* card for fees */}
                  <div className="card min-h-280">
                    <div className="card-body">
                      <div className="dashboard-transaction-container">
                        <div className="details">
                          <div className="big-amount-text">
                            {`${numberFormat(fee.total)}`}
                            <span> NGN</span>
                          </div>
                          <div className="fee-description">
                            {fee.description.slice(
                              0,
                              fee.description.length - 9
                            )}{' '}
                            <span>
                              {fee.description.slice(
                                fee.description.length - 9
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="button-action-container">
                          <div className="row no-gutters align-items-center">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              {fee.paid === 0 && fee.paid_id ? (
                                <Link
                                  to={`transaction/details/${fee.paid_id}`}
                                  className={[
                                    `btn btn-primary btn-primary-color ${
                                      canDisableFee(fee, fees) ? 'disabled' : ''
                                    }`
                                  ]}
                                >
                                  Retry payment
                                </Link>
                              ) : fee.paid === 1 && fee.paid_id ? (
                                <Link
                                  to={`transaction/details/${fee.paid_id}`}
                                  className="btn btn-gray"
                                >
                                  Payment details
                                </Link>
                              ) : (
                                <Link
                                  to={`${
                                    canDisableFee(fee, fees)
                                      ? ''
                                      : `fee/details/${fee.payment_id}`
                                  }`}
                                  className={[
                                    `btn btn-primary btn-primary-color ${
                                      canDisableFee(fee, fees) ? 'disabled' : ''
                                    }`
                                  ]}
                                >
                                  Make Payment
                                </Link>
                              )}
                            </div>
                            <div className="days-remaining col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              {fee.paid === 1 && fee.paid_id ? (
                                <Fragment>
                                  <i>
                                    <img
                                      src={require('../assets/transaction-success.svg')}
                                      className="svg transaction"
                                      alt="Academic Details"
                                    />
                                  </i>
                                  <span className="paid">Paid </span>
                                </Fragment>
                              ) : fee.paid === 0 && fee.paid_id ? (
                                <Fragment>
                                  <i>
                                    <DaysRemainingIcon status="pending" />
                                  </i>
                                  Pending
                                  <span className="due-date">
                                    {getDueTime(fee.date_due)}
                                  </span>
                                </Fragment>
                              ) : fee.paid === 0 && fee.paid_id === null ? (
                                <Fragment>
                                  <i>
                                    <DaysRemainingIcon status="" />
                                  </i>
                                  {getDueTime(fee.date_due)}
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <i>
                                    <TransactionSuccessIcon />
                                  </i>
                                  {getDueTime(fee.date_due)}
                                </Fragment>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* card for fees */}
                </div>
              );
            })
          )}
        </div>
        {/* end card container dashboard transaction */}
        {/* news divider */}
        <hr className="section-divider" />
        {/* end news divider */}
        {/* card for other fees display  */}
        {loading ? (
          ''
        ) : (
          <div className="row no-gutters">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <div className="row no-gutters">
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                      Other Fees
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                      {/* <a href="#" className="card-link">
                        ##
                        <i className="fa fa-angle-right" />
                      </a> */}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row other-fees-container">
                    {this.state.sundry_fees.map((fee, index) => (
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-4"
                        key={index}
                      >
                        {/* card for other fees */}
                        <div className="other-fees-detail">
                          <div className="details">
                            <div className="big-amount-text">
                              {numberFormat(fee.total)} <span>NGN</span>
                            </div>
                            <div className="fee-description">
                              {fee.description}
                            </div>
                          </div>
                          <div className="button-action-container">
                            <div className="row no-gutters">
                              {fee.paid === 1 && fee.paid_id ? (
                                <Fragment>
                                  <div className="col-xs-12 col-sm-12 col-md-8 col-lg-9">
                                    <Link
                                      to={`transaction/details/${fee.paid_id}`}
                                      className={[
                                        `btn btn-gray,
                                        ${
                                          canDisableFee(fee, this.state.fees)
                                            ? 'disabled'
                                            : ''
                                        }
                                      `
                                      ]}
                                    >
                                      Payment details
                                    </Link>
                                  </div>
                                  <div className="days-remaining col-xs-12 col-sm-12 col-md-4 col-lg-3">
                                    <i>
                                      <img
                                        src={require('../assets/transaction-success.svg')}
                                        className="svg transaction"
                                        alt="Academic Details"
                                      />
                                    </i>
                                    <span className="paid">Paid</span>
                                  </div>
                                </Fragment>
                              ) : fee.paid === 0 && fee.paid_id ? (
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                  <Link
                                    to={`${`fee/details/${fee.payment_id}`}`}
                                    className={[
                                      `btn btn-primary btn-primary-color w-100 ${
                                        canDisableFee(fee, fees)
                                          ? 'disabled'
                                          : ''
                                      }
                                        `
                                    ]}
                                  >
                                    Retry Payment
                                  </Link>
                                </div>
                              ) : (
                                <Link
                                  to={`${`fee/details/${fee.payment_id}`}`}
                                  className={[
                                    `btn btn-primary btn-primary-color w-100 ${
                                      canDisableFee(fee, fees) ? 'disabled' : ''
                                    }`
                                  ]}
                                >
                                  Make Payment
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* other fees */}
                      </div>
                    ))}
                  </div>
                  {/* <p className="text-center">
                    <a href="#" className="more-fees-link">
                      See All Fees
                    </a>
                  </p> */}
                </div>
              </div>
              {/* card for outstanding fees */}
            </div>
          </div>
        )}
        {/* end card for news display   */}
      </main>
    );
  }
}

export default Fees;
